<template>
  <div class="fluid page_content">
    <div class="page_heading">
      <div class="col-5 module_heading" role="heading" aria-level="1">
        <span class="transfer_articulation_icon icon-list"></span>
        <span class="transfer_articulation_title ml-3">Transfer Articulation Management</span>
      </div>

      <div class="col-7 btn_container pagination_sty3">
        <b-btn @click="upload" aria-label="upload">upload</b-btn>
        <b-btn @click="showDeleteConfirm" aria-label="delete all" :disabled="(mappings.length === 0)">delete all</b-btn>
      </div>
    </div>

    <div class="course-management-section">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
            <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" v-model="keyword" placeholder="filter by course" aria-label="filter by course" @keyup.enter="keyupEvent">
            <button type="button" class="btn btn_srh" @click="keyupEvent" aria-label="search mappings">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="course-management-table-container">
        <table class="table b-table table-bordered border">
          <thead class="thead-light text-center">
            <tr>
              <th class="first-column">From Institution</th>
              <th class="second-column">From Course</th>
              <th class="third-column">To Course</th>
              <th class="fourth-column">Course Credit</th>
              <th class="fifth-column"></th>
            </tr>
          </thead>
          <tbody v-if="mappings.length > 0">
            <tr v-for="mapping in mappings">
              <td class="first-column text-center">
                <span>{{mapping.sourceInstitutionOpenId}}</span><br/>
              </td>
              <td class="second-column text-center">
                <span>{{mapping.sourceCatalogId}}</span><br/>
              </td>
              <td class="third-column">
                <span>{{mapping.targetCatalogId}}</span>                
              </td>
              <td class="fourth-column">
                <span>{{mapping.credit}}</span>
              </td>
              <td class="fifth-column text-center">
                <b-btn @click="viewTransferLogic(mapping)" aria-label="view transfer logic">view transfer logic</b-btn>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="no-result" style="text-align: center;">No Mappings Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <b-modal id="modal-delete-all-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered :header-bg-variant="'popup-header'">
        <div style="text-align: center;">
           <h6>Are you sure you want delete all ({{totalElements}}) transfer articulation mappings?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="$refs.deleteConfirmModal.hide()">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteAll" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="$refs.deleteConfirmModal.hide()" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="modal-transfer-logic" ref="transferLogicModal" hide-footer no-close-on-backdrop no-close-on-esc centered size="md" :header-bg-variant="'popup-header'">
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt">
            <span><strong>Transfer Logic</strong></span>
          </div>
          <div class="btn_container float-right">
            <button class="btn_close" aria-label="close" @click="$refs.transferLogicModal.hide()">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div style="margin-left: 8rem;">
          <code>
            <template v-for="logic in transferLogics">
              <pre style="font-size: medium;"><strong>{{logic | pretty}}</strong></pre>
            </template>
          </code>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import '../../../assets/module/css/course/courseList.min.css'

  export default {
    name: 'transfer-articulation-mapping-list',
    data () {
      return {
        mappings: [],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        keyword: '',
        transferLogics: []
      }
    },
    mounted () {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadTransferArticulationMappingList()
      }, 500)
    },
    methods: {
      ...mapActions([
        'loadTransferArticulationMappings',
        'loadDeleteAllTransferArticulationMappings'
      ]),
      loadTransferArticulationMappingList (keyword) {
        this.loadTransferArticulationMappings({page: this.page, count: this.pageSize, keyword: keyword}).then(result => {
          this.mappings = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.$refs.loadingModal.hide()
        })
      },
      upload () {
        return this.$router.push({name: 'transferArticulationMappingUpload'})
      },
      showDeleteConfirm () {
        this.$refs.deleteConfirmModal.show()
      },
      deleteAll () {
        this.$refs.deleteConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.loadDeleteAllTransferArticulationMappings().then(res => {
          if (res) {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Successfully deleted all the transfer articulation mappings'
            })
          }
          this.loadTransferArticulationMappingList()
        })
      },
      viewTransferLogic (mapping) {
        this.transferLogics = []
        this.transferLogics = mapping.transferLogics
        this.$refs.transferLogicModal.show()
      },
      keyupEvent (event) {
        this.page = 0
        this.loadTransferArticulationMappingList(this.keyword)
      },
      resetPage () {
        this.page = 0
        this.keyword = ''
        this.loadTransferArticulationMappingList()
      },
      prev () {
        this.page -= 1
        if (this.keyword.length > 0) {
          this.loadTransferArticulationMappingList(this.keyword)
        } else {
          this.loadTransferArticulationMappingList()
        }
      },
      next () {
        this.page += 1
        if (this.keyword.length > 0) {
          this.loadTransferArticulationMappingList(this.keyword)
        } else {
          this.loadTransferArticulationMappingList()
        }
      }
    }
  }
</script>

<style>
  .transfer_articulation_icon {
    float:left;
    width:30px;
    font-size:30px;
    color:#34b2ff;
    margin:3px 3px 0 0 !important;
  }

  .transfer_articulation_title {
    font-size: 22px;
    font-weight: 400;
    float: left;
    margin-top: 4px;
  }

  .popup_head_txt {
    font-size: 1.1rem;
    float: left;
    color: #323232;
  }

  .bg-popup-header {
    background: #c0c0c0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/app/transfer/components/TransferArticulationMappingList.vue